"use strict";
document.addEventListener('DOMContentLoaded', function () {
    var html = document.querySelector('html');
    html.classList.remove('no-js');
}, false);
